import {
    type ApiResult,
    type ArtifactMetaDataResponse,
    type ArtifactType,
    type BaseParams,
    type PostParams,
    Request,
} from '@app/client/common';
import { type ArtifactSignatureParams, type SignatureResponse } from '@app/client/common/structs/emoji/emoji';
import { type ArtifactBreakdownResponse, type ArtifactsResponse } from '@app/store/types/artifacts';

import { links } from '../../links';

export async function getCollection(params: BaseParams): Promise<ApiResult<ArtifactsResponse>> {
    return Request.getRequest<ArtifactsResponse>({
        ...params,
        target: links.artifacts().collection(),
    });
}

export async function getCollectionMetadata(params: BaseParams): Promise<ApiResult<ArtifactMetaDataResponse[]>> {
    return Request.getRequest<ArtifactMetaDataResponse[]>({
        ...params,
        target: links.artifacts().artifactTypesMeta(),
    });
}

export async function getBreakdown(params: BaseParams): Promise<ApiResult<ArtifactBreakdownResponse>> {
    return Request.getRequest<ArtifactBreakdownResponse>({
        ...params,
        target: links.artifacts().single().breakdown,
    });
}

export async function generateSignature(
    params: BaseParams & PostParams<ArtifactSignatureParams> & { artifact_type: ArtifactType; artifact_id: string },
): Promise<ApiResult<SignatureResponse>> {
    return Request.postRequest<SignatureResponse>({
        ...params,
        target: links.artifacts().single(params.artifact_type).generateSignature(params.artifact_id),
    });
}

export const artifactsCalls = { getCollection, getCollectionMetadata, getBreakdown, generateSignature };
